import React from 'react'
import { Map } from 'immutable'
import { ImageSize } from './imageSizes'

export type ImageBase = {
  alt: string
  urls: Map<ImageSize, string>
}

export const emptyImage: ImageBase = {
  alt: "",
  urls: Map<ImageSize, string>(),
}

export type ImageOptions = {
  src: ImageSize
  srcset?: Map<ImageSize, string>
  pictureSources?: PictureSources[]
  sizes?: string
  width?: string
  height?: string
  lazyload: boolean
  placeholder?: string
}

export type PictureSources = {
  srcset: Map<ImageSize, string>
  sizes?: string
  media: string
  type?: string
}

export const Image = (
  props: ImageBase &
    ImageOptions & {
      classNames: {
        image: string
        picture?: string
      }
    }
) => {
  const { urls, alt, classNames, src, width, height, srcset, lazyload, pictureSources } = props
  const sizes = props.sizes !== undefined ? props.sizes : 'auto'
  const placeholder = props.placeholder !== undefined ? props.placeholder : undefined
  const img = (
    <img
      loading={lazyload == true ? "lazy" : "eager"}
      fetchpriority={lazyload == true ? undefined : "high"}
      className={classNames.image}
      width={width}
      height={height}
      alt={alt}
      src={placeholder ? placeholder : urls?.get(src) || undefined}
      sizes={sizes}
    />
  )

  // Check if urls has valid pictures before showing picture
  if (!hasValues(urls)) return img;

  return (srcset || pictureSources) ? (
    <picture className={classNames.picture}>
      {pictureSources ?
        pictureSources.map((source) => (
          <source
            srcSet={source.srcset
              .filter((value, key) => urls.get(key) !== undefined)
              .map((value, key) => `${urls.get(key)} ${value}`)
              .join(',')}
            sizes={source.sizes}
            media={source.media}
            type={source.type || undefined}
          />
        ))
      : <></>}
      {srcset ?
        <source
          srcSet={srcset
            .filter((value, key) => urls.get(key) !== undefined)
            .map((value, key) => `${urls.get(key)} ${value}`)
            .join(',')
          }
          sizes={sizes}
          type="image/webp"
        />
      : <></>}
      {img}
    </picture>
  ) : (
    img
  )
}

const hasValues = ( map: Map<ImageSize, string> ) => {
  return !map.contains('')
}